import { FoundationUtils } from '../../../../utils/foundation-utils';
import { DATA_STRUCTURING_99667Parameters, FunctionName } from '../../../../utils/parameters';
import { SmartcareActions } from './smartcare-actions';
import { SmartCareAudioTranscription } from './smartcare-audio-transcription';
import { SmartCareStreamTranscription } from './smartcare-stream-transcription';

enum SmartcareTranscriptionMethod {
  AUDIO = 'A',
  STREAM = 'S'
}

export class SmartCareTranscriptionFactory {

  public static createTranscriptionService(smartCareUrl: string, tags: {[key:string]:string} = {}): SmartcareActions {
    const typeOfTranscriptionMethod = FoundationUtils
      .findModuleParam(FunctionName.DATA_STRUCTURING_99667, DATA_STRUCTURING_99667Parameters.METHOD_OF_SENDING_THE_TRANSCRIPTION_TO_SMARTCARE) as SmartcareTranscriptionMethod;

    if (typeOfTranscriptionMethod !== null && typeOfTranscriptionMethod === SmartcareTranscriptionMethod.AUDIO) {
      return new SmartCareAudioTranscription(smartCareUrl);
    }
    return new SmartCareStreamTranscription(smartCareUrl, tags);
  }
}